import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseService } from '../services/baseService.service';
import { Observable, BehaviorSubject } from 'node_modules/rxjs';
import { map } from 'node_modules/rxjs/operators';
import { of } from 'node_modules/rxjs';
import { ReportUserDataModel, ReportUser } from '@src/models/reportUser.model';
import { UserModel } from '@src/models/user.model';
import { environment } from '@src/environments/environment';
import { FilterModel } from '@src/models/filter.model';
import { SpecificTrainingModel } from '@src/models/specificTraining.model';
import { KbwUpdateUserModel } from '@src/models/kbwUpdateUser.model'; 

@Injectable({providedIn: 'root'})
export class ReportService extends BaseService {

    constructor(private http: HttpClient) {
        super();
     }
     getUsers<ReportUserDataModel>(filter: FilterModel) {
         const headers = this.createRequestHeader();
         // const currentPage = filter.pageIndex * filter.pageSize;
         return this.http.post<ReportUser>(`${environment.apiUrl}/ReportUserData/GetReportUsersData`,
         filter, { headers: headers
        });
     }
     getKbwLast<ReportUserData>(count: number){
        const headers = this.createRequestHeader();
        return this.http.post<ReportUser>(`${environment.apiUrl}/ReportUserData/GetLastKbwRegistrations`,
            10, { headers: headers
           });
     }
     removeAllTrainings(userId: number) {
         const headers = this.createRequestHeader();
         // API returns plain text; force text response to prevent JSON parse errors surfacing as failures.
         return this.http.post(`${environment.apiUrl}/ReportUserData/CancelAllTrainings`, userId, {headers: headers, responseType: 'text' as 'json'});
     }
     removeSpecificTraining(specificTraining: SpecificTrainingModel) {
        const headers = this.createRequestHeader();
          // API returns a plain-text payload; force text response to avoid JSON parse errors surfacing as failures.
          return this.http.post(`${environment.apiUrl}/ReportUserData/CancelSpecificTraining`,
          specificTraining, {headers: headers, responseType: 'text' as 'json'});
     }
     updateKbwUserData(user: KbwUpdateUserModel){
        const headers = this.createRequestHeader();
        return this.http.post(`${environment.apiUrl}/ReportUserData/updateKbwUser`,
            user, {headers: headers});
     }



    // getData<ExamCompleteModel>() {
    //     const headers = this.createRequestHeader();
    //     return this.http.get<ExamCompleteModel>(`${this.serverUrl}/exam/getexamdata`, { headers: headers });
    // }

    // sendFinishExamData<ExamSummary>(model: ExamFinishedModel) {
    //     const headers = this.createRequestHeader();
    //     return this.http.post<ExamSummary>(`${this.serverUrl}/exam/CheckExamData`,
    //     model, {headers: headers});
    // }
    // getExams<ExamBaseData>() {
    //     const headers = this.createRequestHeader();
    //     return this.http.get<ExamBaseData>(`${this.serverUrl}/user/GetTrainingTypes`, { headers: headers});
    // }
}

